import Nav from 'components/Nav';
import Content from 'components/Content';
import Typography from 'components/Typography';
import Spacer from 'components/Spacer';
import Footer from 'components/Footer';
import MemberBio from 'components/MemberBio';

import classes from 'styles/pages/About/About.module.scss';

import Pfizer from 'public/brands/pfizer.svg';
import Ebay from 'public/brands/ebay.svg';
import Kpmg from 'public/brands/kpmg.svg';
import HomeDepot from 'public/brands/home-depot.svg';
import Pepsi from 'public/brands/pepsico.svg';

import { EMPLOYERS_LINK } from 'utils/constants/urls';
import { LAWYER_HOURLY_RATE, LAWYER_HOURLY_RATE_SOURCE } from 'utils/constants/attorneys';

const companies = [Pfizer, Ebay, Kpmg, HomeDepot, Pepsi];

const navLinks = [
  { text: 'Why MetLife Legal Plans?', href: '/why-enroll' },
  { text: 'How We Work', href: '/#how-we-work' },
  { text: 'Reviews', href: '/#reviews' },
  { text: 'About Us', href: '/about-us' },
  { text: 'Who We Serve', href: '/who-we-serve' },
  { text: 'For Employers', href: EMPLOYERS_LINK, external: true },
];

const team = [
  {
    blue: true,
    left: true,
    imageName: '01-Meray-El-Khoury.png',
    name: 'Meray El-Khoury',
    title: 'Chief Executive Officer',
    description: [
      'Meray El-Khoury has spent her career helping businesses adapt, grow, and stay ahead of change, combining strategic vision with a relentless focus on customer value. As Chief Executive Officer of MetLife Legal Plans, she leads the company’s strategy, growth, and operations. An accomplished insurance executive and actuary, Meray brings more than two decades of leadership experience helping organizations navigate evolving markets and unlock new opportunities.',
      'Since joining MetLife in 2019, she has held several senior leadership roles, most recently serving as Chief Insurance Officer for MetLife Australia. There, she helped strengthen the business by modernizing products, expanding market reach, and positioning the organization for long-term growth. Meray holds a Bachelor of Commerce majoring in Actuarial Studies from Macquarie University, is a Fellow of the Institute of Actuaries of Australia, and completed Harvard University’s Advanced Management Program.',
      'At MetLife Legal Plans, she is focused on making legal services more accessible and relevant to the needs of today’s consumers, helping more people navigate life’s everyday legal moments with confidence while creating value for customers, employers, and partners.',
    ],
  },
  {
    blue: true,
    left: false,
    imageName: '02-Lilja-Altman.png',
    name: 'Lilja Altman',
    title: 'General Counsel',
    description: [
      'Lilja manages the legal function for MetLife Legal Plans. In addition to ensuring that our business remains compliant, she provides legal support for our proactive growth strategies. A longtime member of MetLife’s U.S. Insurance Law Department since 2019, she previously led legal support for Accident and Health. Prior to that, she served as counsel in MetLife’s Litigation Department, advising on a broad range of claims litigation across Disability and Life, as well as retail matters.',
      'She began her legal career as a litigator at White & Case LLP and Kennedy Berg LLP, where she handled complex litigation matters, including securities and commercial actions. A gardener, runner, and music lover, she holds a J.D. from Rutgers School of Law-Newark and a B.S. in Law and Justice with a minor in Psychology from The College of New Jersey.',
    ],
  },
  {
    blue: true,
    left: true,
    imageName: '03-Gary-Glacken.png',
    name: 'Gary Glacken',
    title: 'Chief Financial Officer',
    description: [
      'A dedicated finance professional, Gary is responsible for the overall financial management of MetLife Legal Plans, including accounting, financial planning and analysis, pricing, and development of strategies for profitable growth.',
      'Gary most recently served as a vice president and CFO for MetLife’s Small Market and Specialty business segments. In addition to his 15 years of service within MetLife, he also held roles at Horizon Blue Cross Blue Shield, Ernst & Young, and Prudential. Gary holds Bachelor of Science and Master of Business Administration degrees in finance from Rutgers University.',
    ],
  },
  {
    blue: true,
    left: false,
    imageName: '04-Claire-Godlewski.png',
    name: 'Claire Godlewski',
    title: 'VP, Customer Experience',
    description: [
      'As Vice President of Customer Experience, Claire manages three member-facing area teams of our organization: our Client Service Center; our Attorney Network and Claims Management Team; and our Operations Team. Her teams are responsible for all member-related engagement. Claire is dedicated to enhancing customer satisfaction and building strong customer relationships.',
      'Claire joined MetLife Legal Plans in 2002 as a Regional Business Account Specialist. Prior to her current position, she managed the Operations, Regional Business, and  National Accounts’ administration teams as our Chief Administration Officer. Claire is a graduate of Ohio University with a Bachelor of Business Administration.',
    ],
  },
  {
    blue: true,
    left: true,
    imageName: '07-Shannon-Nihoff.png',
    name: 'Shannon Nihoff',
    title: 'Chief People Leader',
    description: [
      'Shannon is a strategic and seasoned human resource expert. With the understanding that our people are our greatest asset, she is responsible for setting the direction and plan for all people-related strategies and operations, working closely with our CEO and Senior Leadership Team.',
      'Shannon comes to us from MetLife, where she dedicated 16 years as a strategic business partner, supporting both domestic and international business segments, including U.S. Group Benefits and Internal Audits. She is a graduate of Geneva college and holds a Bachelor of Science in Human Resources.',
    ],
  },
  {
    blue: true,
    left: false,
    imageName: '08-Ben-Porch.png',
    name: 'Ben Porch',
    title: 'Chief Technology Officer',
    description: [
      'Ben drives our technological vision—ensuring that innovation and strategy move in tandem with business growth. With over 20 years of executive and hands-on experience, he leads our tech initiatives, focusing on scalability, risk management, and efficiency—all while delivering customer-centric solutions.',
      'A recognized leader across healthcare, finance, consulting, e-commerce, and government, Ben has earned multiple business awards for his contributions to the technology sector. He holds degrees in Criminal Justice and Information Systems from American University and an M.S. in Advanced Technologies, IT Systems from Johns Hopkins University.',
    ],
  },
  {
    blue: true,
    left: true,
    imageName: '05-Andrea-Quadros.png',
    name: 'Andrea Quadros',
    title: 'VP, Strategy and Product Development',
    description: [
      'Andrea is an experienced strategist with a passion for talent and focuses on delivering MetLife Legal Plans’ growth and transformation plan. She is responsible for driving solutions and building organizational culture and capabilities to deliver a successful strategy. Andrea previously led Strategy and Planning for MetLife’s U.S. Business and held sales, product, and marketing positions across multiple MetLife regions. She started her career at McKinsey & Company in India, followed by strategy roles across developed and emerging markets. Andrea holds an MBA from Harvard Business School and a Bachelor’s degree from St. Xavier’s College, India.',
    ],
  },
  {
    blue: true,
    left: false,
    imageName: '06-Loi-Stoddard-Graham.png',
    name: 'Loi Stoddard-Graham',
    title: 'VP, Business Growth and Retention',
    description: [
      'Loi is responsible for product strategy, marketing, competitive positioning, sales support, and implementation. A savvy business strategist, she enhances legal plan products with new features, builds innovative distribution relationships, and brokers our expansion into new markets—to create the best legal product for working families.',
      'A 20-year MetLife veteran, her experience spans the gamut, including product management of PlanSmart Financial Wellness, business development for MetLife Global Employee Benefits, Chief of Staff to the head of Employee Benefit Sales in U.S. Group Benefits, and roles within the Financial Management Group, Retail Sales, Group Sales, and Underwriting. She holds a Bachelor of Science from Fordham University, Masters Certificate in Business Intelligence from Villanova University, and attended a management program at the Tuck School of Business.',
    ],
  },
];

const About = () => (
  <>
    <Nav links={navLinks} />
    <main role="main">
      <div className={classes.header}>
        <div className={classes.tagline}>
          <div className={classes.aboutHeading}>
            <Typography bold className={classes.about}>
              About Us
            </Typography>
            <Spacer v={48} />
            <Typography className={classes.protection}>Protection at every step.</Typography>
          </div>
        </div>
      </div>

      <Spacer v={50} />

      <Content>
        <div className={classes.whoWeAre}>
          <Typography className={classes.section} unsetColor>
            Who <strong>We Are</strong>
          </Typography>

          <Spacer v={50} />

          <Typography>
            Since 1977, MetLife Legal Plans, formerly Hyatt Legal Plans, has been helping employees
            and families navigate legal issues by providing legal consultation and representation
            through a simple to use and cost-effective legal plan. Today, we are the country's
            largest provider of legal benefits. With a vast attorney network, an award-winning
            customer service team, and new digital solutions for legal needs&#8212;we're proud to do
            our part in expanding legal access to Americans.
          </Typography>

          <Spacer v={16} />

          <Typography>
            Our work is critical to upholding justice, and a culture of Diversity, Equity, and
            Inclusion is integral to how we do business and serve our customers. We're proud to
            offer legal coverage which improves outcomes for a diverse, multi-generational
            workforce. Legal plans improve employees' quality of life by helping with stress,
            feelings of safety, and financial concerns while allowing employers to provide
            competitive benefit packages that appeal to future talent.
          </Typography>
        </div>

        <Spacer v={50} />

        <div className={classes.contentWithPadding}>
          <Typography className={classes.section} style={{ color: '#0091D8' }}>
            What <strong> We Do </strong>
          </Typography>
        </div>

        <div className={classes.gradientBar} />

        <div className={classes.contentWithPadding}>
          <Typography>
            We empower employees by offering protection at every step. For a competitive monthly
            cost, MetLife Legal Plans provides financial security that comes with knowing an
            attorney is helping with your legal matters. Employees have access to a large network of
            over 18,000 qualified and experienced attorneys to help them navigate simple and complex
            legal matters. <strong>Plans cover employees, their spouses, and dependents.</strong>
          </Typography>

          <Spacer v={16} />

          <Typography>Protection at every step is made possible because of:</Typography>

          <Spacer v={16} />

          <div className={classes.contentWithPadding}>
            <div className={classes.whatWeDoItem}>
              <img src="about/icon-cost-effectiveness.png" alt="" className={classes.icon} />
              <div>
                <Typography style={{ color: '#0091D8' }}>
                  <strong> COST-EFFECTIVENESS </strong>
                </Typography>

                <Spacer v={16} />

                <Typography>
                  The average attorney fee runs ${LAWYER_HOURLY_RATE} an hour.<sup>1</sup>{' '}
                  <strong>
                    Compare that to the cost of MetLife Legal Plans for the whole year ($240)
                    <sup>2</sup>.
                  </strong>
                </Typography>
              </div>
            </div>

            <Spacer v={50} />

            <div className={classes.whatWeDoItem}>
              <img src="about/icon-accessibility.png" alt="" className={classes.icon} />
              <div>
                <Typography style={{ color: '#0091D8' }}>
                  <strong>ACCESSIBILITY</strong>
                </Typography>

                <Spacer v={16} />

                <Typography>
                  The plan{' '}
                  <strong>
                    includes over 1,700 self-help documents, and the searchable attorney network
                    makes it easy to find an attorney in your area that meets your needs.
                    Communicate with an attorney via phone, email, or in-person.
                  </strong>
                </Typography>
              </div>
            </div>

            <Spacer v={50} />

            <div className={classes.whatWeDoItem}>
              <img
                src="about/icon-range-of-covered-legal-services.png"
                alt=""
                className={classes.icon}
              />
              <div>
                <Typography style={{ color: '#0091D8' }}>
                  <strong> RANGE OF COVERED LEGAL SERVICES </strong>
                </Typography>

                <Spacer v={16} />

                <Typography>
                  We have one of the most robust legal coverage options in the market, and are
                  rigorously expanding our service offerings, attorney network, and improving the
                  experience.
                </Typography>
              </div>
            </div>
          </div>
        </div>

        <Spacer v={50} />

        <div className={classes.contentWithPadding}>
          <Typography className={classes.section} style={{ color: '#0091D8' }}>
            Powerful and <strong>backed by MetLife </strong>
          </Typography>
        </div>

        <div className={classes.gradientBar} />

        <div className={classes.contentWithPadding}>
          <div className={classes.metlifeBuilding}>
            <img src="/metlife-building-2.png" alt="" />
          </div>

          <div className={classes.pictureText}>
            <Typography bold>
              For over 25 years, we’ve been part of MetLife’s suite of products. Legal plans are a
              versatile employee benefit.
            </Typography>

            <Spacer v={16} />

            <Typography>
              Legal plans work standalone but also supplements other MetLife benefits such as Pet
              Insurance, Vision, Dental, and Critical Illness. From start to finish, MetLife is
              committed to your success. Consolidating multiple product offerings with a single
              carrier streamlines the end-to-end service experience and creates valuable
              administrative efficiencies for customers.
            </Typography>
          </div>
        </div>

        <Spacer v={50} />

        <div className={classes.contentWithPadding}>
          <Typography className={classes.section} style={{ color: '#A5CC56' }}>
            How <strong> We Stand Apart </strong>
          </Typography>
        </div>

        <div className={classes.gradientBar} />

        <div className={classes.contentWithPadding}>
          <Typography>
            We ensure the highest level of care when helping resolve your legal issues. Our Client
            Service Center is consistently recognized for best-in-class customer service by the
            <a
              href="https://stevieawards.com/aba/metlife-legal-plans-best-legal-website"
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              American Business Awards{' '}
            </a>
            and our attorney network includes legal professionals with firms averaging 25 years of
            experience.
          </Typography>
        </div>

        <Spacer v={25} />

        <div className={classes.awards}>
          <img src="about/All-Awards.png" className={classes.medal} alt="" />
        </div>

        <Spacer v={25} />

        <div className={classes.contentWithPadding}>
          <Typography>
            <strong>
              We offer coverages for money matters, home and real estate, family and personal
              issues, civil lawsuits, estate planning, immigration help, document prep, elder-care
              issues, vehicle and driving incidents, and more.
            </strong>
            <br />
            Additionally, we are on the lookout for enhancements that are inclusive of the legal
            needs of all our members.
          </Typography>

          <Spacer v={50} />

          <Typography>
            <strong> Recently, we've expanded our offerings to include: </strong>
          </Typography>

          <Spacer v={24} />

          <div>
            <li>
              Coverage of up to eight parents or grandparents through Plus Parents <sup>3</sup>
            </li>
            <li>
              Credit monitoring and premium identity protection through Aura
              <sup>&reg;</sup>
              <sup>4</sup>
            </li>
            <li>
              Caregiving benefits through Family First<sup>&reg;</sup>
              <sup>5</sup>
            </li>
            <li> Divorce coverage</li>
            <li> Reproductive Assistance Law coverage </li>
            <li>
              Digital Estate Planning solution—complete wills, trusts, health proxy, and
              power-of-attorneys quickly and easily online
            </li>
          </div>

          <Spacer v={24} />
        </div>

        <Spacer v={50} />
      </Content>

      <div className={classes.sponsorsWrapper}>
        <div className={classes.sponsors}>
          {companies.map((Logo, idx) => (
            <div key={idx} className={classes.logo}>
              <Logo />
            </div>
          ))}
        </div>
        <div className={classes.banner}>
          <div className={classes.bannerText}>
            <Typography>
              <strong>
                OVER 220 OF
                <br />
                FORTUNE 500<sup>&copy;</sup>
                <br />
                COMPANIES{' '}
              </strong>
              TRUST
              <br />
              US WITH THEIR
              <br />
              EMPLOYEES
            </Typography>
          </div>
        </div>
      </div>

      <Content>
        <Spacer v={48} />
        <div className={classes.meetTeamHeader}>
          <Typography className={classes.meetTeam}>
            Meet <b>Our Team</b>
          </Typography>
          <Spacer h={24} />
        </div>

        <Spacer v={48} />

        {team.map(({ blue, left, imageName, name, title, description }) => {
          return (
            <MemberBio
              key={name}
              blue={blue}
              left={left}
              imageName={imageName}
              name={name}
              title={title}
              bio={description}
            />
          );
        })}

        <Typography className={classes.infoText}>
          <sup>1</sup>Average hourly rate of ${LAWYER_HOURLY_RATE}.00 based on years of legal
          experience, {LAWYER_HOURLY_RATE_SOURCE}.
          <br />
          <sup>2</sup>This cost is based on an average monthly rate for the legal plan of $20.
          <br />
          <sup>3</sup>For individuals covered under a New York insurance policy, parents and
          grandparents must reside in the same household as the insured to utilize the Plus Parents
          benefit.
          <br />
          <sup>4</sup>Aura is a product of Aura Sub, LLC. Aura Sub, LLC. is not affiliated with
          MetLife, and the services and benefits they provide are separate and apart from any
          MetLife product. It’s impossible to guarantee prevention of all identity theft and
          monitoring of all transactions. An additional fee applies to offer the Aura Identity &
          Fraud Protection service.
          <br />
          <sup>5</sup>This benefit provides the participant and their family a highly trained Care
          Team, provided by Family First, Inc., to navigate caregiving challenges. Family First is
          not a corporate affiliate of MetLife Legal Plans.
          <br />
          <br />
          Group legal plans provided by MetLife Legal Plans, Inc., Cleveland, Ohio. In certain
          states, group legal plans are provided through insurance coverage underwritten by
          Metropolitan General Insurance Company, Warwick, RI. Some services not available in all
          states. No service, including consultations, will be provided for: 1) employment-related
          matters, including company or statutory benefits; 2) matters involving the employer,
          MetLife and affiliates and plan attorneys; 3) matters in which there is a conflict of
          interest between the employee and spouse or dependents in which case services are excluded
          for the spouse and dependents; 4) appeals and class actions; 5) farm and business matters,
          including rental issues when the participant is the landlord; 6) patent, trademark and
          copyright matters; 7) costs and fines; 8) frivolous or unethical matters; 9) matters for
          which an attorney client relationship exists prior to the participant becoming eligible
          for plan benefits. For all other personal legal matters, an advice and consultation
          benefit is provided. Additional representation is also included for certain matters.
          Please see your plan description for details. MetLife® is a registered trademarks of
          MetLife Services and Solutions, LLC, New York, NY.
        </Typography>
      </Content>
    </main>

    <Footer />
  </>
);

export default About;
